export const PRODUCT_TOUR_STEPS = [
  {
    id: 'sidebar-nav',
    target: '[data-tour-id="sidebar-nav"]',
    mobileTarget: '[data-tour-id="mobile-menu-button"]',
    title: 'Your Navigation Menu',
    content: 'This is your sidebar menu — click here to explore all your Work Van features.',
    mobileContent: 'Tap the menu button to open your navigation.',
    position: 'right',
    mobilePosition: 'bottom',
    advance: 'click-target'
  },
  {
    id: 'products-pricing-menu',
    target: '[data-tour-id="menu-products-pricing"]',
    mobileTarget: '[data-tour-id="menu-mobile-products-pricing"]',
    title: 'Products & Pricing',
    content: 'Click here to set up your products and pricing. This makes quoting 10x faster.',
    position: 'right',
    mobilePosition: 'bottom',
    advance: 'click-target'
  },
  {
    id: 'add-product-button',
    target: '[data-tour-id="add-product-button"]',
    title: 'Add Your First Product',
    content: 'Click here to add your first product or service.',
    position: 'bottom',
    advance: 'click-target'
  },
  {
    id: 'tour-complete',
    target: null,
    title: "You're All Set!",
    content: 'Your first product is ready. Add more anytime from Products & Pricing.',
    position: 'center',
    advance: 'next-button',
    waitForEvent: 'tour:product-created'
  }
];
